<template>
  <div>
    <div class="bar">
		<div class="bar-logo"><img src="../../assets/logo.png"></div>
		<div class="bar-nav">
			<router-link class="bar-list-a" :to="obj.path" v-for="(obj,index) in barList" :key="index">
			  <div class="bar-list">
			  
			    <span>{{obj.name}}</span>
			  </div>
			</router-link>
		</div>
    
	  <div class="bar-menu">
		  <ul>
			<!--  <li><img src="../../assets/icon31.png"></li> -->
			   <li><router-link to="/user/orders"><img src="../../assets/icon32.png"></router-link></li>
			    <li><router-link to="/product/cart"><img src="../../assets/icon33.png"></router-link></li>
		  </ul>
	  </div>
    </div>

  </div>
</template>
<script>
import index from "@/assets/bar/index.png";
import index_action from "@/assets/bar/index_action.png";
import serve from "@/assets/bar/serve.png";
import serve_action from "@/assets/bar/serve_action.png";
import user from "@/assets/bar/user.png";
import user_action from "@/assets/bar/user_action.png";
import notice from "@/assets/bar/notice.png";
import notice_action from "@/assets/bar/notice_action.png";
import act from "@/assets/bar/act.png";
import act_action from "@/assets/bar/act_action.png";


export default {
  data() {
    return {
      barBtn: 0,
      barList: [
        {
          name: "HOME",
          path: "/index/home",
          icon: index,
          icon_action: index_action,
        },
        {
          name: "PRODUCT",
          path: "/product",
          icon: serve,
          icon_action: serve_action,
        }, {
          name: "NEWS",
          path: "/news",
          icon: notice,
          icon_action: notice_action,
        }, {
          name: "APPRECIATION WORKES",
          path: "/works",
          icon: act,
          icon_action: act_action,
        },
        {
          name: "CONTACK",
          path: "/contact",
          icon: user,
          icon_action: user_action,
        },
      ],
    };
  },
  methods: {
    getBarBtn(index) {
      this.barBtn = index;
    },
  },
};
</script>

<style lang='scss' scoped>
.bar {
display: flex;
justify-content: space-between;
align-items: center;
border-bottom: 3px solid #EEEEEE;

  width: 100%;
  height: 94px;
  padding:10px 61px;
  box-sizing: border-box;
  background: white;
	.bar-logo{
		
		img{
			width: 152px;
			height: 73px;
		}
	}
	.bar-nav{
		width: 590px;
		display: flex;
		justify-content: space-evenly;
	}
	.bar-menu{
		width: 200px;
	
		li{
			width: 22px;
			height: 22px;
			float: left;
			margin-right: 20px;
			img{
				width: 100%;
				height: 100%;
				image-rendering: -webkit-optimize-contrast;
			}
		}

	}
  .bar-list {
	
    .bar-list-img {
    
      width: 49px;
      height: 49px;
      margin: auto;
      box-sizing: border-box;
      img {
        width: 100%;
      }
      .icon_action {
        display: none;
      }
      .icon {
        display: block;
      }
    }
  }
  //

  //
  .bar-nav{
	  .router-link-active{
	  	  border-bottom: 2px solid #000000;
	  	  .icon_action {
	  	    display: block !important ;
	  	  }
	  	  .icon {
	  	    display: none !important ;
	  	  }
	  }
	  .router-link-exact-active {
	   border-bottom: 2px solid #000000;
	    .icon_action {
	      display: block !important ;
	    }
	    .icon {
	      display: none !important ;
	    }
	  }
  }

}

</style>